module.exports = __webpack_public_path__ + "img/img3.063ab30b.jpg";